
import DefaultHeader from '@/components/thank-you/DefaultHeader.vue'
export default {
  name: 'DefaultThankYouPage',
  components: {
    DefaultHeader,
  },
  layout: 'landingpagefooter',
  data() {
    return {
      title: `Thank you - ${this.$config.siteTitle}`,
      description: 'Thank you for your purchase!',
    }
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.description,
        },
        { hid: 'og:title', property: 'og:title', content: this.title },
        { hid: 'og:url', property: 'og:url', content: this.pageUrl },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.description,
        },

        // twitter card
        { hid: 'twitter:title', name: 'twitter:title', content: this.title },
        { hid: 'twitter:url', name: 'twitter:url', content: this.pageUrl },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: this.description,
        },
      ],
    }
  },
}
